import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';
import DestinationsSection from './components/DestinationsSection';
import ExchangeSection from './components/ExchangeSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import GallerySection from './components/GallerySection';
import InstagramSection from './components/InstagramSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import StatsSection from './components/StatsSection';
import WorldMapSection from './components/WorldMapSection';

export default function Home() {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.Lenis) return;

    const lenis = new window.Lenis({
      duration: 1.2,
      easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return (
    <main className="relative w-full min-h-screen bg-background-50">
      <Navbar />

      <HeroSection />

      <WorldMapSection />

      <AboutSection />

      <StatsSection />

      <DifferentiatorsSection />

      <DestinationsSection />

      <ExchangeSection />

      <HowItWorksSection />

      <div id="depoimentos">
        <TestimonialsSection />
      </div>

      <GallerySection />

      <InstagramSection />

      <div id="faq">
        <FAQSection />
      </div>

      <CTASection />

      <Footer />
    </main>
  );
}